import type { NLTMessage } from '../types/nlt';

export interface NltPatchDialogSourceMessage {
  role: 'user' | 'assistant';
  content: string;
  includeInDialog?: boolean;
  patchRunId?: string;
}

/**
 * Build dialog for POST /nlt/patch:
 * prior turns → optional single `system` with {"history":[{"human","ai"},...]};
 * latest user text → one trailing `human`.
 */
export function buildNltPatchDialog(
  messages: NltPatchDialogSourceMessage[],
  latestHuman: string
): NLTMessage[] {
  const history: Array<{ human?: string; ai?: string }> = [];
  let pendingHuman: string | null = null;

  for (const message of messages) {
    if (message.includeInDialog === false) continue;
    const content = message.content.trim();
    if (!content) continue;

    if (message.role === 'user') {
      if (pendingHuman) history.push({ human: pendingHuman });
      pendingHuman = content;
      continue;
    }

    if (pendingHuman) {
      history.push({ human: pendingHuman, ai: content });
      pendingHuman = null;
    } else {
      history.push({ ai: content });
    }
  }

  if (pendingHuman) history.push({ human: pendingHuman });

  const dialog: NLTMessage[] = [];
  if (history.length > 0) {
    dialog.push({
      type: 'system',
      content: JSON.stringify({ history }),
    });
  }

  const trimmedLatest = latestHuman.trim();
  if (trimmedLatest) {
    dialog.push({ type: 'human', content: trimmedLatest });
  }

  return dialog;
}
